import { GroupData, Choice } from 'APP/Converse/SearchCard/types'
import { DisplayResult } from './types'

export const MIN_SEARCH_TEXT_LENGTH = 2

export const getNormalizedSearchResults = (
  groupData: GroupData,
  choices: Choice[],
  searchResults: string[] | null
): DisplayResult[] | null => {
  if (!searchResults || !groupData || !choices) {
    return null
  }

  if (searchResults.length === 0) {
    return []
  }

  const normalizedResults: DisplayResult[] = []
  const choicesById = new Map<string, Choice>()
  const groupDataById = new Map(Object.entries(groupData))

  choices.forEach((choice) => {
    if (choice.id !== undefined) {
      choicesById.set(choice.id, choice)
    }
  })

  for (const searchId of searchResults) {
    const choice = choicesById.get(searchId)

    if (choice?.group_id) {
      const group = groupDataById.get(choice.group_id)

      if (group) {
        normalizedResults.push({
          id: choice.id,
          displayL2: choice.display,
          displayL1: group.display,
        })
      }
    }
  }

  return normalizedResults
}
